import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-req-general-operario-ver',
  templateUrl: './req-general-operario-ver.component.html',
  styleUrls: ['./req-general-operario-ver.component.css']
})
export class ReqGeneralOperarioVerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
